import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';

import { getBorderRadius } from 'Components/utils';

const styles = theme => ({
  root: {
    display: 'initial',
    background: 'white',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
  },
  text: {
    ...getBorderRadius(theme.radius.sm, { all: true }),
    whiteSpace: 'nowrap',
  },
});

const SplitterText = ({
  classes,
  text,
  elevation,
  variant,
}) => (
  <Paper
    className={classes.root}
    elevation={elevation}
  >
    <Typography
      variant={variant}
      className={classes.text}
      component="span"
      color="inherit"
    >
      {text}
    </Typography>
  </Paper>
);

SplitterText.defaultProps = {
  elevation: 0,
  variant: 'h6',
};

SplitterText.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  variant: PropTypes.string,
  elevation: PropTypes.number,
};

export default withStyles(styles)(SplitterText);
